const SPECIAL_OFFERS_ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
};

export { SPECIAL_OFFERS_ACTIONS };
